import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function exportSelectedServices(services, formatPrice) {
  if (!Array.isArray(services) || services.length === 0) {
    console.warn('No services provided for export');
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Services');

  // Define columns
  worksheet.columns = [
    { header: 'Id', key: 'id', width: 10 },
    { header: 'Item', key: 'item', width: 30 },
    { header: 'Year', key: 'year', width: 10 },
    { header: 'City', key: 'city', width: 20 },
    { header: 'Adult Price (Gross)', key: 'adultPriceGross', width: 20 },
    { header: 'Child Price (Gross)', key: 'childPriceGross', width: 20 },
    { header: 'Adult Price (Net)', key: 'adultPriceNet', width: 20 },
    { header: 'Child Price (Net)', key: 'childPriceNet', width: 20 },
    { header: 'Price (Gross)', key: 'priceGross', width: 20 },
    { header: 'Type', key: 'type', width: 15 },
    { header: 'Tax', key: 'tax', width: 15 },
    { header: 'Tax Rate', key: 'taxRate', width: 15 },
    { header: 'Category', key: 'category', width: 20 },
    { header: 'Remarks', key: 'remarks', width: 30 },
    { header: 'Cancellation', key: 'cancellation', width: 30 },
    { header: 'Supplier', key: 'supplier', width: 20 },
  ];

  // Add rows for services
  const selectedData = services.map(service => ({
    id: service.id,
    item: service.attributes?.item || '',
    year: service.attributes?.year || '',
    city: service.attributes?.cities?.data?.map(city => city.attributes.city).join(', ') || '',
    adultPriceGross: formatPrice ? formatPrice(service.attributes?.adultPrice_gross) : service.attributes?.adultPrice_gross || 0,
    childPriceGross: formatPrice ? formatPrice(service.attributes?.childPrice_gross) : service.attributes?.childPrice_gross || 0,
    adultPriceNet: formatPrice ? formatPrice(service.attributes?.adultPrice_net) : service.attributes?.adultPrice_net || 0,
    childPriceNet: formatPrice ? formatPrice(service.attributes?.childPrice_net) : service.attributes?.childPrice_net || 0,
    priceGross: formatPrice ? formatPrice(service.attributes?.price) : service.attributes?.price || 0,
    type: service.attributes?.type || '',
    tax: service.attributes?.tax || '',
    taxRate: service.attributes?.rate ? `${service.attributes.rate}%` : '',
    category: service.attributes?.catagory || '',
    remarks: service.attributes?.remarks || '',
    cancellation: service.attributes?.cancellation || '',
    supplier: service.attributes?.supplier || '',
  }));

  worksheet.addRows(selectedData);

  // Create buffer and save file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  saveAs(blob, 'selected_services.xlsx');
}